'use strict';
var base = require('./base');

module.exports = function () {
    base.selectAttribute();
    base.colorAttribute();
    base.selectSize();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.availability();
    base.addToCart();
}
